import { render, staticRenderFns } from "./CredorUsuario.vue?vue&type=template&id=16895387&"
import script from "./CredorUsuario.vue?vue&type=script&lang=js&"
export * from "./CredorUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports